<template>
  <v-tooltip right>
    <template v-slot:activator="{ on }">
      <v-icon v-on="on" :color="inactived ? 'grey' :status.color">
        {{status.icon}}
      </v-icon>
    </template>
    <span>{{status.message}}</span>
  </v-tooltip>
</template>

<script>

import router from "@/router.js";
export default {
  name: 'IconStatus',
  props:{
    status:{
      type: Object,
      required: false,
      default: {},
    },
    inactived:{
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>
<style scoped>
</style>